var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_378_12047)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14.4893C0 6.75729 6.26803 0.489258 14 0.489258C21.732 0.489258 28 6.75729 28 14.4893C28 22.2212 21.732 28.4893 14 28.4893C6.26803 28.4893 0 22.2212 0 14.4893ZM13.5807 11.8686L13.6101 12.3531L13.1205 12.2938C11.3382 12.0664 9.78116 11.2952 8.45909 10.0001L7.81282 9.3575L7.64633 9.83204C7.29377 10.8899 7.51899 12.0071 8.25347 12.7584C8.64517 13.1736 8.55703 13.2329 7.88136 12.9858C7.64633 12.9067 7.44065 12.8474 7.42111 12.877C7.35257 12.9462 7.58753 13.8459 7.77362 14.2018C8.02824 14.6961 8.54723 15.1806 9.11522 15.4673L9.59507 15.6947L9.02708 15.7045C8.47869 15.7045 8.45909 15.7144 8.51789 15.922C8.71372 16.5646 9.48733 17.2468 10.3491 17.5434L10.9563 17.751L10.4274 18.0674C9.64402 18.5221 8.72352 18.7792 7.80302 18.799C7.36231 18.8088 7 18.8484 7 18.8781C7 18.9769 8.19473 19.5305 8.89 19.7481C10.9758 20.3907 13.4534 20.1139 15.314 19.0164C16.636 18.2354 17.958 16.6833 18.575 15.1806C18.9079 14.3798 19.2409 12.9166 19.2409 12.2147C19.2409 11.7599 19.2702 11.7006 19.8186 11.1568C20.1418 10.8404 20.4454 10.4944 20.5042 10.3955C20.6021 10.2077 20.5923 10.2077 20.0929 10.3758C19.2605 10.6724 19.143 10.6328 19.5543 10.1879C19.8578 9.87159 20.2201 9.29817 20.2201 9.13012C20.2201 9.10042 20.0733 9.14989 19.9068 9.23885C19.7305 9.33772 19.3388 9.48601 19.045 9.57502L18.5162 9.74308L18.0364 9.41682C17.772 9.23885 17.3998 9.04116 17.204 8.98183C16.7046 8.84341 15.9407 8.86318 15.4903 9.02138C14.2662 9.46623 13.4926 10.6131 13.5807 11.8686Z",
    fill: "#FFFCF7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_378_12047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0 0.489258)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.7ab354973d43776910849de0f2ed661f.svg";
export { ForwardRef as ReactComponent };